<!-- Localized -->
<template>
    <div class="print-d-block flex flex-col space-y-4 overflow-y-auto px-2 overflow-x-hidden">
        <div class="mt-2">
            <div class="mb-2 flex space-x-2">
                <div class="w-1/3 lg:w-1/4 font-semibold text-left py-2 pr-3 text-gray-400">{{ $t('components.tools.media_monitoring.matched_entity') }}</div>
                <div class="w-full p-2">
                    <div class="flex justify-between items-center" :identifier="`['data']['EntityDetails']['articles'][${articleIndex}]['extractedEntities']`">
                        <span class="space-y-2">
                            <template>{{ expandedCard.api_all_data?.data?.articles?.[articleIndex]?.extractedEntities?.[0].text }}</template>
                        </span>
                    </div>
                </div>
            </div>
            <div class="mb-2 flex space-x-2">
                <div class="w-1/3 lg:w-1/4 font-semibold text-left py-2 pr-3 text-gray-400">{{ $t('components.tools.media_monitoring.country') }}</div>
                <div class="w-full p-2">
                    <div class="flex justify-between items-center" :identifier="`['data']['EntityDetails']['articles'][${articleIndex}]['extractedTerritories']`">
                        <span class="space-y-2">
                            <template>{{ getCountries }}</template>
                        </span>
                    </div>
                </div>
            </div>
            <div class="mb-2 flex space-x-2">
                <div class="w-1/3 lg:w-1/4 font-semibold text-left py-2 pr-3 text-gray-400">{{ $t('components.tools.media_monitoring.us_state') }}</div>
                <div class="w-full p-2">
                    <div class="flex justify-between items-center" :identifier="`['data']['EntityDetails']['articles'][${articleIndex}]['extractedTerritories']`">
                        <span class="space-y-2">
                            <template>{{ getStates }}</template>
                        </span>
                    </div>
                </div>
            </div>
            <div class="mb-2 flex space-x-2">
                <div class="w-1/3 lg:w-1/4 font-semibold text-left py-2 pr-3 text-gray-400">{{ $t('components.tools.media_monitoring.publisher') }}</div>
                <div class="w-full p-2">
                    <div class="flex justify-between items-center" :identifier="`['data']['EntityDetails']['articles'][${articleIndex}]['publisher']`">
                        <span class="space-y-2">
                            <template>{{ expandedCard.api_all_data?.data?.articles?.[articleIndex]?.publisher }}</template>
                        </span>
                    </div>
                </div>
            </div>
            <div class="mb-2 flex space-x-2">
                <div class="w-1/3 lg:w-1/4 font-semibold text-left py-2 pr-3 text-gray-400">{{ $t('components.tools.media_monitoring.published_date') }}</div>
                <div class="w-full p-2">
                    <div class="flex justify-between items-center" :identifier="`['data']['EntityDetails']['articles'][${articleIndex}]['publishedDate']`">
                        <span class="space-y-2">
                            <template>{{ getFormattedTime(expandedCard.api_all_data?.data?.articles?.[articleIndex]?.publishedDate, "dd MMM yyyy") }}</template>
                        </span>
                    </div>
                </div>
            </div>
            <div class="border-t border-gray-300 pt-2 flex float-left items-center whitespace-normal break-words">
                {{ expandedCard.api_all_data?.data?.articles?.[articleIndex]?.body }}
            </div>
        </div>
    </div>
</template>
<script>
import { DateTime } from "luxon";
import {get} from "lodash";
import adverseMixin from "@shared/tools/mixins/adverseMixin";
import printDataMixin from "@shared/tools/mixins/printDataMixin";
import highlighterMixin from "@shared/mixins/highlighterMixin";


export default {
    data() {
        return {
            isPrintLoader: false,
            printDone: false,
        };
    },
    mixins: [adverseMixin, printDataMixin, highlighterMixin],
    props: {
        expandedCard: {
            type: Object,
        },
        isResultExpanded: {
            type: Boolean,
        },
        source: {
            type: String,
        },
        isComparisonModeOn: {
            type: Boolean,
            default: false,
        },
        articleIndex: {
            type: Number,
            default: 0,
        }
    },
    computed: {
        isMedia() {
            return this.adverseCard?.doc.media && this.adverseCard?.doc.media.length > 0;
        },
        adverseCardKey() {
            return this.expandedCard?.key;
        },
        adverseCard() {
            return this.expandedCard?.api_all_data ?? {};
        },

        profileData() {
            return get(this.adverseCard, "data.EntityDetails.AKAs", []).length > 0 || get(this.adverseCard, "data.EntityDetails.AdditionalInfo", []).length || get(this.adverseCard, "data.EntityDetails.IDs", []).length || get(this.adverseCard, "data.EntityDetails.Addresses", []).length;
        },

        getCountries() {
            const data = this.expandedCard.api_all_data?.data?.articles?.[this.articleIndex]?.extractedTerritories?.map((el) => el.country);
            return data?.filter((el) => el)?.join(",");
        },

        getStates() {
            const data = this.expandedCard.api_all_data?.data?.articles?.[this.articleIndex]?.extractedTerritories?.map((el) => el.adminOne);
            return data?.filter((el) => el)?.join(",");
        }
    },
    watch: {},
    mounted() {
    
    },
    methods: {
        get,

        getFormattedDate(date) {
            if (date) {
                return date.split("-").reverse().join("-")
            }
            else return ''
        },

        getFormattedTime(ts, format) {
            let date = DateTime.fromISO(ts);
            return format ? date.toFormat(format) : date.toFormat("EEE, dd MMM yyyy, hh:mm:ss a");
        },

        getIdentifierMapping(key, index, listLength) {
            let mapping = "";
            if (key === "dateDetails")
                mapping = `['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue']['@Day'] 
                ['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue']['@Month'] 
                ['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue']['@Year']`;
            else if (key === "countryDetails") {
                for (let i = 0; i < listLength; i++) mapping += ` ['data']['${this.source}']['CountryDetails'][${index}]['CountryValue'][${i}]['@name']`;
            } else if (key === "dates") {
                if (listLength >= 0)
                    mapping = `['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue'][${listLength}]['@Day']
                    ['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue'][${listLength}]['@Month']
                    ['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue'][${listLength}]['@Year']`;
                else
                    mapping = `['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue']['@Day']
                    ['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue']['@Month']
                    ['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue']['@Year']`;
            } else if (key === "SanctionRefs") mapping = `['data']['${this.source}']['SanctionsReferences'][${index}]['data']['@name'] ['data']['${this.source}']['SanctionsReferences'][${index}]['Value']['#text']`;
            else if (key === "SanctionRefsSince") mapping = `['data']['${this.source}']['SanctionsReferences'][${index}]['@SinceDay'] ['data']['${this.source}']['SanctionsReferences'][${index}]['@SinceMonth'] ['data']['${this.source}']['SanctionsReferences'][${index}]['@SinceYear']`;
            else if (key === "SanctionRefsTo") mapping = `['data']['${this.source}']['SanctionsReferences'][${index}]['@ToDay'] ['data']['${this.source}']['SanctionsReferences'][${index}]['@ToMonth'] ['data']['${this.source}']['SanctionsReferences'][${index}]['@ToYear']`;
            else if (key === "OtherSegments") {
                mapping = `['data']['OtherSegments'][${index}]['Source']`;
                for (let i = 0; i < listLength; i++) 
                    mapping += ` ['data']['OtherSegments'][${index}]['SubCategories'][${i}]`;
            } else if (key === "Enforcements") {
                mapping = `['data']['Enforcements'][${index}]['Source'] ['data']['Enforcements'][${index}]['Country'] `;
                for (let i = 0; i < listLength; i++) 
                    mapping += ` ['data']['Enforcements'][${index}]['SubCategories'][${i}]`;
            } else if (key === "PEPs") {
                mapping = `['data']['PEPs'][${index}]['Status'] 
                            ['data']['PEPs'][${index}]['IsPrimary']
                            ['data']['PEPs'][${index}]['Country'] 
                            ['data']['PEPs'][${index}]['AdminUnit']
                            ['data']['PEPs'][${index}]['AdminLevel'] 
                            ['data']['PEPs'][${index}]['CountryRole']
                            ['data']['PEPs'][${index}]['GoverningInstitution']
                            ['data']['PEPs'][${index}]['GoverningRole'] 
                            ['data']['PEPs'][${index}]['EffectiveDate']
                            ['data']['PEPs'][${index}]['ExpirationDate']`;
                for (let i = 0; i < listLength; i++) 
                    mapping += ` ['data']['PEPs'][${index}]['SubCategories'][${i}]`;
            } else if (key === "SOEs__SubCategories") {
                for (let i = 0; i < listLength; i++) 
                    mapping += ` ['data']['SOEs'][${index}]['SubCategories'][${i}]`;
            } else if (key === "SOEs__Domain") {
                for (let i = 0; i < listLength; i++) 
                    mapping += ` ['data']['SOEs'][${index}]['Domain'][${i}]`;
            } else if (key === "AdverseMedias") {
                mapping = `['data']['AdverseMedias'][${index}]['Description']`;
                for (let i = 0; i < listLength; i++) 
                    mapping += ` ['data']['AdverseMedias'][${index}]['SubCategories'][${i}]`;
            }

            return mapping;
        },

        async printPageMediaMonitoring(id, name, print, noPrint) {
            this.printDone = false;
            this.isPrintLoader = true;
            if (!print) {
                let htmlPDF = await this.printData(id, name, noPrint);
                this.$emit("updatePrintStatus", "");
                this.isPrintLoader = false;
                if (noPrint) {
                    return htmlPDF;
                }
            }
        },
    },
};
</script>


<style scoped>
   .tabActions {
    display: flex;
    overflow: hidden;
    overflow-x: auto;
}
/* .scroll-bar {
    height: 10px;
} */
.tabs {
    width: 100%;
    border-bottom: 3px solid var(--brand-accent-neutral);
    cursor: pointer;
    margin: 0.4rem 0;
    font-family: var(--brand-font);
    position: -webkit-sticky;
    position: sticky;
    top: 0px;
    z-index: 10;
    display: flex;
}
.tabContainer {
    width: 100%;
}

.tab {
    transform: translateY(3px);
    border-bottom: 3px solid transparent;
    transition: var(--transition-mnml);
    border-radius: var(--component-border) var(--component-border) 0 0;
    font-size: 16px;
    text-align: center;
    max-width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
::-webkit-scrollbar {
  width: 10px;
  height: 12px;
}
::-webkit-scrollbar:vertical {
     background-color: gray; /* Blue thumb */
  border-radius: 10px;
  border: 2px solid #f1f1f1; 
}

::-webkit-scrollbar-track {
  background: white;
}

::-webkit-scrollbar-thumb {
  background-color: gray; /* Blue thumb */
  border-radius: 10px;
  border: 2px solid #f1f1f1; /* Optional border to make it stand out */
}
@media print {
    .rotate-180 {
        display: none !important;
    }
    .searchIcon {
        display: none !important;
    }
}
</style>
<style>
.cascading-highlighter {
        background-color: #f6f1bb;
    }
@media print {
    .Vue-Toastification__container {
        display: none !important;
    }
    .print-hidden {
        display: none !important;
    }
    .searchIcon {
        display: none !important;
    }
    .relatives-close-associates {
        overflow-x: hidden !important;
    }
    .print-d-block {
        display: block !important;
    }
    table {
        page-break-inside: auto !important;
    }
    table tr {
        page-break-inside: avoid !important;
        page-break-after: auto !important;
        page-break-before: auto !important;
    }
    table th {
        page-break-inside: avoid !important;
        page-break-after: auto !important;
        page-break-before: auto !important;
    }
    table tr div {
        page-break-inside: avoid !important;
        page-break-after: auto !important;
        page-break-before: auto !important;
    }
    table tr:before {
        min-height: 60px !important;
    }
    div {
        page-break-inside: auto !important;
        page-break-after: auto !important;
        page-break-before: auto !important;
        box-sizing: content-box !important;
    }
    tr {
        page-break-inside: avoid !important;
    }
    table {
        table-layout: fixed !important;
    }
    /* table, */
    thead,
    /* tbody, */
    /* tr  */
    /* td, */
    th {
        display: block !important;
    }
    table thead tr {
        top: -9999px !important;
        left: -9999px !important;
        display: none !important;
    }

    table tr:nth-child(odd) {
        background: #f6f8fc !important;
    }
    table tr {
        /* border: none !important;
        border-bottom: 1px solid #eee !important;
        position: relative !important;
        align-items: center !important;
        display: flex !important;
        white-space: normal !important;
        word-wrap: break-word !important;
        padding: 5px 15px !important; */
        width: 100%;
    }
}
</style>
